import React from "react"
import { ProgressSpinner } from "primereact/progressspinner"

function HomeCard({ user }) {
  if (!user) {
    return <ProgressSpinner />
  }

  return (
    <div className="flex flex-column align-items-center justify-content-center">
      <div className="card-container shadow-4">
        <div className="text-3xl font-bold">
          {user?.points.toLocaleString("en-US") || 0} puntos
        </div>
        <div className="text-xl font-light">
          {user?.name_first || ""} {user?.name_last || ""}
        </div>
        <div className="text-sm font-semibold mt-2">
          Referencia: {user?.referral_code || "-"}
        </div>
      </div>
    </div>
  )
}

export default HomeCard
